import { createAction, props } from '@ngrx/store';

import { type } from '@app/util/util';
import { FlightType } from '@search-bar/entities/flight-type';
import { PassengerArrangement } from '@shared/base-search-bar/entities/passenger-arrangement';
import { FlightClass } from '@shared/base-search-bar/entities/flight-class';
import { AutocompletePlaces } from '@search-bar/entities/autocomplete-places';
import { SelectAutocompletePlace } from '@search-bar/entities/select-autocomplete-place';
import { SelectAutocompletePrediction } from '@search-bar/entities/select-autocomplete-prediction';
import { Room } from '@shared/base-search-bar/entities/room.entities';
import { SearchType } from '@search-bar/entities/search-type';
import {
  AutoCompleteDestination, DestinationPlaceInfoPayload, DestinationPlaceInfoResponse, InputDestinationPlace
} from '@shared/base-search-bar/entities/autocomplete-destionation';
import {
  AutoCompleteTravelExtra, InputTravelExtra, TravelExtraActivityInfoPayload
} from '@shared/base-search-bar/entities/autocomplete-travel-extra';

export const fetchDefaultPlaceAction = createAction(
  type('[SearchBar/API] Fetch Default Place'),
  props<{ searchType: SearchType }>()
);
export const fetchDefaultPlaceActionSuccess = createAction(
  type('[SearchBar/API] Fetch Default Place Success'),
  props<{ place: SelectAutocompletePlace }>()
);
export const fetchDefaultAirportActionSuccess = createAction(
  type('[SearchBar/API] Fetch Default Airport Success'),
  props<{ place: SelectAutocompletePlace }>()
);
export const selectDepartureTerminalAction = createAction(
  type('[SearchBar/API] Select Departure Terminal'),
  props<{ place: SelectAutocompletePlace }>()
);
export const selectArrivalTerminalAction = createAction(
  type('[SearchBar/API] Select Arrival Terminal'),
  props<{ place: SelectAutocompletePlace }>()
);
export const searchDefaultPlaceForIpActionSuccess = createAction(
  type('[SearchBar/API] Search Default Place For Ip Success')
);
export const selectDeparturePlaceAction = createAction(
  type('[SearchBar/Data] Select departure place'),
  props<{ selectedPlace: SelectAutocompletePlace }>()
);
export const selectArrivalPlaceAction = createAction(
  type('[SearchBar/Data] Select arrival place'),
  props<{ selectedPlace: SelectAutocompletePlace }>()
);
export const selectFlightTypeAction = createAction(
  type('[SearchBar/Data] Select flight type'),
  props<{ flightType: FlightType }>()
);
export const selectHourTypeAction = createAction(
  type('[SearchBar/Data] Select hour type'),
  props<{ hourType: string[] }>()
);
export const selectDepartureDateAction = createAction(
  type('[SearchBar/Data] Select departure date'),
  props<{ date: Date }>()
);
export const selectArrivalDateAction = createAction(
  type('[SearchBar/Data] Select arrival date'),
  props<{ date: Date }>()
);
export const selectPassengerArrangementAction = createAction(
  type('[SearchBar/Data] Set flightArrangement'),
  props<{ passengerArrangement: PassengerArrangement }>()
);
export const selectFlightClassAction = createAction(
  type('[SearchBar/Data] Select flight class'),
  props<{ flightClass: FlightClass }>()
);
export const searchPlacesAction = createAction(
  type('[SearchBar/Data] Search places'),
  props<{ term: string }>()
);
export const searchPlacesSuccessAction = createAction(
  type('[SearchBar/Data] Search places success'),
  props<{ places: AutocompletePlaces }>()
);
export const selectAirlineAction = createAction(
  type('[SearchBar/Data] Select airline place'),
  props<{ airlineCode: string }>()
);
export const resetAutocomplete = createAction(type('[SearchBar/Data] Reset autocomplete'));
export const addRoomAction = createAction(
  type('[SearchBar/Data] Add new Room'),
  props<{ room: Room }>()
);
export const deleteRoomAction = createAction(
  type('[SearchBar/Data] Delete Room'),
  props<{ index: number }>()
);
export const selectGuestsPerRoomAction = createAction(
  type('[SearchBar/Data] Set Guests Per Room'),
  props<{ guestsPerRoom: Room }>()
);
export const includeBaggageAction = createAction(
  type('[SearchBar/Data] Include baggage'),
  props<{ included: boolean }>()
);
export const resetGuestsPerRoomAction = createAction(type('[SearchBar/Data] Reset Guests Per Room'));
export const setBranchCodeAction = createAction(
  type('[SearchBar/Data] Set BranchCode'),
  props<{ branchCode: string }>()
);
export const resetBranchCodeAction = createAction(type('[SearchBar/Data] Reset BranchCode'));
export const selectDestinationPlaceAction = createAction(
  type('[SearchBar/Data] Select destination place'),
  props<{ selectedPlace: SelectAutocompletePlace }>()
);
export const toggleHeaderEditButtonVisibleAction = createAction(
  type('[SearchBar/Data] Toggle header edit button visible'),
  props<{ value: boolean }>()
);
export const setSalesChannelAction = createAction(
  type('[SearchBar/Data] Set SalesChanelCode'),
  props<{ code: string }>()
);
export const resetSalesChannelAction = createAction(type('[SearchBar/Data] Reset SalesChanelCode'));
export const setPackageStepAction = createAction(type('[SearchBar/Data] Set Package Step'),
  props<{ code: string }>());
export const resetPackageStepAction = createAction(type('[SearchBar/Data] Reset Package Step'));
export const resetInputArrivalPlace = createAction(type('[SearchBar/Data] Reset Arrival Place'));
export const selectPickUpPlaceAction = createAction(
  type('[SearchBar/API] Select Pick Up Place'),
  props<{ place: SelectAutocompletePrediction }>());
export const selectDropOffPlaceAction = createAction(
  type('[SearchBar/API] Select Drop Off Place'),
  props<{ place: SelectAutocompletePrediction }>());
export const selectPickUpTimeAction = createAction(
  type('[SearchBar/API] Select Pick Up Time'),
  props<{ time: string }>());
export const selectDropOffTimeAction = createAction(
  type('[SearchBar/API] Select Drop Off Time'),
  props<{ time: string }>());
export const toggleAutoDiffPlace = createAction(type('[SearchBar/Data] Toggle auto diff drop off place'));

export const searchDestinationPlacesAction = createAction(
  type('[SearchBar/Data] Search destination places'),
  props<{ query: string }>()
);
export const searchDestinationPlacesSuccessAction = createAction(
  type('[SearchBar/Data] Search destination places success'),
  props<{ response: AutoCompleteDestination }>()
);
export const selectHotelDestinationPlaceAction = createAction(
  type('[SearchBar/Data] Select hotel destination place'),
  props<{ selection: InputDestinationPlace }>()
);

export const searchDestinationPlaceInfoAction = createAction(
  type('[SearchBar/Data] Search destination place info'),
  props<{ payload: DestinationPlaceInfoPayload }>()
);
export const searchDestinationPlaceInfoSuccessAction = createAction(
  type('[SearchBar/Data] Search destination place info success'),
  props<{ response: DestinationPlaceInfoResponse }>()
);
export const clearSearchBarDataAction = createAction(type('[SearchBar/Data] Clear search bar data'));
export const setSkipServices = createAction('[SearchBar/Skip Services] Set Skip Services', (value: boolean) => ({ value }));
export const setTabSelectedHome = createAction('[SearchBar/Set Tab Home] Set Tab Home', (value: SearchType) => ({ value }));

export const searchPackageDestinationPlaceInfoSuccessAction = createAction(
  type('[SearchBar/Data] Search package destination place info success'),
  props<{ response: DestinationPlaceInfoResponse }>()
);
export const selectPackageDestinationPlaceAction = createAction(
  type('[SearchBar/Data] Select packages destination place'),
  props<{ selection: InputDestinationPlace }>()
);
export const searchPackageOriginPlaceInfoSuccessAction = createAction(
  type('[SearchBar/Data] Search package origin place info success'),
  props<{ response: DestinationPlaceInfoResponse }>()
);
export const selectPackageOriginPlaceAction = createAction(
  type('[SearchBar/Data] Select packages origin place'),
  props<{ selection: InputDestinationPlace }>()
);

export const searchExtraByQueryAction = createAction(
  type('[SearchBar/Data] Search extra by query'),
  props<{ query: string }>()
);
export const searchExtraByQuerySuccessAction = createAction(
  type('[SearchBar/Data] Search extra by query success'),
  props<{ response: AutoCompleteTravelExtra }>()
);
export const selectTravelExtraInputAction = createAction(
  type('[SearchBar/Data] Select travel extra input'),
  props<{ selection: InputTravelExtra }>()
);
export const searchTravelExtraActivityInfoAction = createAction(
  type('[SearchBar/Data] Search travel extra input info'),
  props<{ payload: TravelExtraActivityInfoPayload }>()
);

export const searchBarActions = {
  fetchDefaultPlaceAction,
  fetchDefaultPlaceActionSuccess,
  fetchDefaultAirportActionSuccess,
  selectDepartureTerminalAction,
  selectArrivalTerminalAction,
  selectDeparturePlaceAction,
  selectArrivalPlaceAction,
  selectPickUpPlaceAction,
  selectDropOffPlaceAction,
  selectPickUpTimeAction,
  selectDropOffTimeAction,
  selectDestinationPlaceAction,
  selectFlightTypeAction,
  selectDepartureDateAction,
  selectArrivalDateAction,
  selectPassengerArrangementAction,
  selectFlightClassAction,
  selectHourTypeAction,
  selectAirlineAction,
  clearSearchBarDataAction
};
